import { Close } from '@project-lary/react-material-symbols';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import etsPipe from 'gcs-common/img/ets-pipe.svg';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const TicketItemPlaceHolder = () => {
  const navigate = useNavigate();
  const isSidebarCollapsed = useSelector(getSidebarCollapsed);
  const cancel = () => {
    navigate(CHAT_ROUTES.TICKETS);
  };

  return (
    <div
      className={`flex w-full cursor-pointer items-center border-0 border-neutral-3 border-b border-solid bg-neutral-3 py-2 ${isSidebarCollapsed ? 'justify-center' : 'justify-between'}`}
    >
      <div className={isSidebarCollapsed ? '' : 'pl-3'} />
      <div className={isSidebarCollapsed ? '' : 'pl-2'}>
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#D9D9E0]">
          <img src={etsPipe} alt="ETS-PIPE" className="object-contain" />
        </div>
      </div>
      {!isSidebarCollapsed && (
        <>
          <div className="flex-1 overflow-hidden px-3">
            <span className="truncate text-ellipsis text-base text-neutral-12">Neue Ersatzteilanfrage</span>
          </div>
          <div className="flex flex-col items-end pr-4">
            <IconButton Icon={Close} size="base" iconSize="text-2xl" variant="ghost_neutral" onClick={() => cancel()} />
          </div>
        </>
      )}
    </div>
  );
};

export default TicketItemPlaceHolder;
